import type { InjectionKey } from 'vue';
import { TOnMove, TOnRemove } from '../types';

export interface UploaderContext {
  size: 'medium' | 'small' | 'mini' | 'tiny';
  direction: string;
  name: string;
  preview: boolean;
  pasteAutoUpload: boolean;
  multiple: boolean;
  disabled: boolean;
  move: boolean;
  remove: boolean;
  emit: (evt: 'change' | 'update:modelValue', ...args: any[]) => void;
  uploadFiles(files: FileList): Promise<void>;
  onMove?: TOnMove;
  onRemove?: TOnRemove;
}

export const uploaderKey: InjectionKey<UploaderContext> = 'uploader' as any;
